// Types
import type { DataJournalType } from "pages/Finance/Transaction/utils"

// Utils
import { getDiscount } from "pages/Finance/Transaction/utils"

// Types
interface Type {
  amount: number
  coa_name: string
  position: 1 | 2
}

export function getJournalAmount(
  datajournal: DataJournalType[],
  isSpendMoneyPosition: boolean,
  isTaxInclusive: boolean
): Type[] {
  // Vars
  const data: Type[] = []

  datajournal.map((item) => {
    // Functions
    const getSubtotal = (): number => {
      if (isTaxInclusive) {
        return Math.round(item.amount - getDiscount(item.amount, item.rate))
      }
    
      return item.amount
    }

    data.push({
      amount: Math.round(getSubtotal()),
      coa_name: item.coa_name,
      position: isSpendMoneyPosition ? 1 : 2
    })

    if (item.rate > 0) {
      data.push({
        amount: Math.round(getDiscount(item.amount, item.rate)),
        coa_name: isSpendMoneyPosition ? item.tax_coa_paid : item.tax_coa_collect,
        position: isSpendMoneyPosition ? 1 : 2
      })
    }

    return null
  })

  return data
}